module.exports = __webpack_public_path__ + "static/media/kaple-knihy.d201cea4.jpg";